import React, { Component } from 'react';
import { CirclePicker } from 'react-color';
import _ from 'lodash';

class BendTimeSettings extends Component {

    state = {
        settings: this.props.settings
    }

    generateSettings() {
        const settings = _.keys(this.props.settings);
        const inputs = [];
        const colors = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#282c34", "#00bcd4", "#009688", "#000000", "#607d8b", "#ffffff"]
        settings.forEach(setting => {
            const option = this.props.settings[setting];
            inputs.push(
                <div key={setting}>
                    <div className="col">
                        <label>{setting.replace(/_/g, ' ')}</label>
                    </div>
                    <div className="col">
                        <input className="settings-input" defaultValue={this.state.settings[setting].value} name={setting} type="hidden" />
                        <CirclePicker colors={colors} color={this.state.settings[setting].value} onChange={this.handleColorChange({ setting })} />
                    </div>
                </div>
            )
        });
        return inputs;
    }

    handleColorChange = ({ setting }) => ({ hex }) => {
        console.log(setting);
        console.log(hex);
        const settings = _.clone(this.state.settings);
        settings[setting].value = hex;
        this.setState({ settings });
    }

    handleChange(color, event) {
        console.log(color);
        console.log(event);
        // const settings = _.clone(this.state.settings);
        // settings[e.target.name].value = e.target.value;
        // this.setState({ settings });
    }

    render() {
        return (
            <div>
                <div className="popup-option" style={this.props.showSettingsInput ? {} : { display: 'none' }}>
                    <div className="popup-container settings">
                        {this.generateSettings()}
                        <div>
                            <div className="col">
                                <button onClick={this.props.setSettings.bind(this)}>Set</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default BendTimeSettings;